const STORAGE_KEY = 'wispr_billing_intent'
const TTL_MS = 30 * 60 * 1000
export const BILLING_PATH = '/app/settings/billing'

/** Remember that a redirected visitor was headed to billing. Pathname only; no-op for any other path. */
export function captureBillingIntent(pathname: string): void {
  if (pathname !== BILLING_PATH) return
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ intent: 'billing', expiresAt: Date.now() + TTL_MS }))
  } catch {
    // Storage unavailable — degrade to no restore.
  }
}

/**
 * Read-and-clear. Returns BILLING_PATH once when a valid, unexpired intent exists, else null.
 * The target is always this hardcoded literal — the stored value must never be fed to navigate().
 */
export function consumeBillingIntent(): typeof BILLING_PATH | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    if (stored === null) return null
    sessionStorage.removeItem(STORAGE_KEY)
    const parsed: unknown = JSON.parse(stored)
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      (parsed as { intent?: unknown }).intent === 'billing' &&
      Number.isFinite((parsed as { expiresAt?: unknown }).expiresAt) &&
      Date.now() <= (parsed as { expiresAt: number }).expiresAt
    ) {
      return BILLING_PATH
    }
    return null
  } catch {
    return null
  }
}
